import { Navigate } from 'react-router';
import styled from 'styled-components';
import { ErrorComponent } from './Error';
import { ValidUrlDefinition } from './helpers/validateNextUrl';
import { useNextUrl } from './hooks/useNextUrl';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
`;

export interface AuthenticateProps {
  target: ValidUrlDefinition;
  token: string;
}

export const Authenticate = ({ target, token }: AuthenticateProps) => {
  const data = useNextUrl(target, token);

  if (data.isError) {
    return <ErrorComponent />;
  }

  if (data.isLoading) {
    return <Root />;
  }
  return <Navigate to={data.url} />;
};
